/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import { Checkbox, List } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import {
  tableData,
  planTypeData,
  drugData,
  priceLevelonClickValidations,
  priceLevelonBlurValidations,
  generateQuarter,
} from './utils';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  drugFamilyTableData,
  manuFactureHead,
} from '../gridComponents/tableHeaders';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  redirectURLLink,
  isArr,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  STATUS_MSG,
  SUCCESS_MSG,
  MNFC_NDC_ERROR_MSG,
  NO_DATA_FOUND_ERROR,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  getManufactirerList,
  getAllDrugFamilies,
  getMaintanancePriceHeaderDetails,
  getPlanTypeDescription,
  dispatchMaintanancePriceDetails,
  getRebatePrograms,
  storePriceSearchInputData,
  storeMfgId,
  setSelectedDrugInStore,
} from '../store/actions';

const RebatePriceSearch = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [fullScreenView1, setFullScreenView1] = React.useState(false);
  const [fullScreenView2, setFullScreenView2] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [drugFamilyList, setDrugFamilyList] = React.useState([]);
  const [gridApi, setGridApi] = React.useState(null);
  const [tableState, setTableState] = React.useState(false);
  const [tableGridApi, setTableGridApi] = useState([]);
  const [gridParams, setGridParams] = useState(null);
  const [gridParams2, setGridParams2] = React.useState(null);
  const [initialCall, setInitialCall] = useState(false);
  const [rebatePgmList, setRebatePgmList] = React.useState([]);
  const getInputValues = useSelector(
    (state) => state.sharedState.PriceDetails.priceLevelSearchInputdata
  );
  const setSelectedDrugFam = useSelector(
    (state) => state.sharedState.PriceDetails.setSelectedDrugFam
  );
  const getErrorMsgs = useSelector(
    (state) => state.sharedState.PriceDetails.priceDetailsErrors
  );

  const [inputValues, setInputValues] = React.useState(getInputValues);
  const rebatePgmErrorMsg =
    getErrorMsgs?.length > 0
      ? _.map(getErrorMsgs, (l) =>
          l.field === 'rebateProgram' ? l.message : null
        )
      : null;

  const quarterErrorMsg =
    getErrorMsgs?.length > 0
      ? _.map(getErrorMsgs, (l) => (l.field === 'quarter' ? l.message : null))
      : null;
  React.useEffect(() => {
    if (getErrorMsgs?.length > 0 && (rebatePgmErrorMsg || quarterErrorMsg)) {
      setErrorMessages(getErrorMsgs.map((data) => data.message));
    } else {
      setErrorMessages([]);
    }
  }, [getErrorMsgs]);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const handleChange = (e) => {
    let { value } = e.target;
    if (e.target.name === 'quarter' && value.length > 1) {
      value = value.replace(/(?<=.{1})./, (char) => char.toUpperCase());
    }
    setInputValues({ ...inputValues, [e.target.name]: value });
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsgs && getErrorMsgs.length > 0) {
      tabHighLigther('/rebatePriceSearch', true);
    } else {
      tabHighLigther('/rebatePriceSearch', false);
    }
  }, [JSON.stringify(getErrorMsgs)]);

  const handleOnBlur = (e) => {
    dispatch(storePriceSearchInputData(inputValues));
    const { name, value } = e.target;
    const test = priceLevelonBlurValidations(
      inputValues,
      getErrorMsgs,
      dispatch,
      setInputValues,
      name
    );
    if (name === 'quarter') {
      setInputValues({ ...inputValues, quarter: autoFormateDate(value) });

      dispatch(
        getManufactirerList({
          rebateProgramCd: inputValues.rebateProgram,
          quarter: autoFormateDate(value),
          mfgTypeCd: 'C',
        })
      );
    }
  };
  const gridRef = React.useRef();
  const { getManufacturerList, getAllDrugList, headerPriceDetails, mfgId } =
    useSelector((state) => state.sharedState.PriceDetails);

  // set full screen click icon button
  const handleFullScreenView = (key) => {
    if (key === 1) {
      setFullScreenView1(!fullScreenView1);
    } else {
      setFullScreenView2(!fullScreenView2);
    }
  };

  React.useEffect(() => {
    // setInputValues({ ...inputValues, rebateProgram: '-1' });
    if (inputValues?.planType) {
      getRebatePrograms(inputValues?.planType).then((res) =>
        setRebatePgmList(res)
      );
    }
  }, [inputValues?.planType]);

  React.useEffect(() => {
    if (
      (inputValues?.planType === 'SUPP' || inputValues?.planType === 'COMM') &&
      inputValues?.rebateProgram !== '-1' &&
      inputValues?.quarter?.length === 6
    ) {
      setErrorMessages([]);
      setLoading(true);
      setInitialCall(true);
      dispatch(
        getManufactirerList({
          rebateProgramCd: inputValues.rebateProgram,
          qtr: inputValues.quarter,
          mfgTypeCd: 'C',
        })
      );
    }
  }, [inputValues]);

  const onGridReady = (params) => {
    const arr = [];

    if (params) {
      if (mfgId?.loadMfgGrid) {
        params.api.forEachNode((node) => arr.push(node.data));
        if (arr?.length) {
          dispatch(storeMfgId({ mfgId: arr?.[0]?.mfgId, loadMfgGrid: true }));
        }
        params.api.forEachNode(
          (node) => node?.rowIndex === 0 && node?.setSelected(true)
        );
      } else {
        // const sortedList = getManufacturerList?.mfgGridDetails?.sort((a, b) =>
        //   a.mfgId.localeCompare(b.mfgId)
        // );
        // const gridRowSelect = sortedList?.findIndex(
        //   (obj) => obj['mfgId'] === mfgId?.mfgId
        // );
        if (mfgId?.mfgId) {
          params.api.forEachNode(
            (node) =>
              node?.data?.mfgId === mfgId.mfgId && node?.setSelected(true)
          );
        } else {
          params.api.forEachNode(
            (node) => node?.rowIndex === 0 && node?.setSelected(true)
          );
          dispatch(
            storeMfgId({
              mfgId: params?.api?.data?.[0]?.mfgId,
              loadMfgGrid: true,
            })
          );
        }
      }
      setGridParams(params);
    }
  };

  const onGridReadyDrugFamily = (params) => {
    if (params) {
      if (setSelectedDrugFam && drugFamilyList) {
        params.api.forEachNode(
          (node) =>
            node?.data?.familySeqNum === setSelectedDrugFam.familySeqNum &&
            node?.setSelected(true)
        );
      } else {
        params.api.forEachNode(
          (node) => node?.rowIndex === 0 && node?.setSelected(true)
        );
      }
      setGridParams2(params);
    }
  };

  React.useEffect(() => {
    if (getManufacturerList?.mfgGridDetails?.length > 0) {
      setLoading(false);
      let manufacturer = [];
      setErrorMessages([]);
      setTableState(true);
      manufacturer = getManufacturerList?.mfgGridDetails.map((data) => {
        return {
          mfgId: data.mfgId,
          mfgName: data.mfgName,
        };
      });
      const sortedList = manufacturer?.sort((a, b) =>
        a.mfgId.localeCompare(b.mfgId)
      );
      setManufacturerList(sortedList);

      requestAnimationFrame(() => onGridReady(gridParams));
    } else {
      if (initialCall) {
        setErrorMessages([NO_DATA_FOUND_ERROR]);
      }
      setLoading(false);
      setManufacturerList([]);
      setDrugFamilyList([]);
    }
  }, [getManufacturerList]);

  React.useEffect(() => {
    if (getManufacturerList?.mfgGridDetails?.length > 0) {
      const sortedList = getManufacturerList?.mfgGridDetails?.sort((a, b) =>
        a.mfgId.localeCompare(b.mfgId)
      );
      dispatch(
        storeMfgId({
          mfgId: mfgId?.mfgId !== '' ? mfgId?.mfgId : sortedList[0].mfgId,
          loadMfgGrid: mfgId?.loadMfgGrid,
        })
      );
      dispatch(
        getAllDrugFamilies({
          mfgId: mfgId?.mfgId ? mfgId?.mfgId : sortedList[0].mfgId,
          rebateProgramCd: inputValues.rebateProgram,
          qtr: inputValues.quarter,
        })
      );
    }
  }, [getManufacturerList, mfgId?.loadMfgGrid]);

// First useEffect: processes and sets drug family list
React.useEffect(() => {
  if (getAllDrugList) {
    const drugFamilyList =
      getAllDrugList?.rebatePriceDetailDrugFamiliesLinkedWithMfg?.map(
        (data) => ({
          familySeqNum: data.familySeqNum,
          familyName: data.familyName,
          mfgId: data.mfgId,
        })
      ) || [];
    setDrugFamilyList(drugFamilyList);
  }
}, [getAllDrugList]);

// Second useEffect: triggers on drugFamilyList update
React.useEffect(() => {
  if (drugFamilyList.length > 0) {
    // Optionally wrap in requestAnimationFrame if grid depends on DOM layout
    requestAnimationFrame(() => {
      onGridReadyDrugFamily(gridParams2);
    });
  }
}, [drugFamilyList]);


  const onSelectAction = (param, key) => {
    dispatch(storeMfgId({ mfgId: param.data.mfgId, loadMfgGrid: false }));
    dispatch(
      getAllDrugFamilies({
        mfgId: param.data.mfgId,
        rebateProgramCd: inputValues.rebateProgram,
        qtr: inputValues.quarter,
      })
    );
    dispatch(setSelectedDrugInStore(null));
    const gridSelect = getManufacturerList?.mfgGridDetails?.findIndex(
      (obj) => obj.mfgId === mfgId
    );
  };

  const onClickOnViewPriceDetail = async (e) => {
    const results = await getMaintanancePriceHeaderDetails({
      rpc: inputValues.rebateProgram,
      familyId: e?.data.familySeqNum,
      mfg: mfgId?.mfgId,
      qtr: inputValues.quarter,
    });
    dispatch(
      getPlanTypeDescription({
        codeDomainList: ['PLAN_TYPE_CD'],
      })
    );
    if (results?.status === '001') {
      dispatch(dispatchMaintanancePriceDetails(results));
      dispatch(
        storePriceSearchInputData({
          ...getInputValues,
          mfgId: e.data.mfgId,
          familySeq: e.data.familySeqNum,
        })
      );
      if (
        results?.rebatePriceDetailsHeaderResponseVO
          ?.maintainRebateProgramHeaderVO?.length > 0
      ) {
        dispatch(setSelectedDrugInStore(e.data));
        redirectURLLink(
          '/rebatePriceDetails',
          'Rebate Price Details',
          history,
          dispatch
        );
      } else {
        setErrorMessages([MNFC_NDC_ERROR_MSG]);
      }
    }
  };

  return (
    <div className=" tabs-container" data-testid="claim-audit-detail">
      <Spinner load={loading} />
      <CustomSeparator parent1="Maintain" parent2="Rebate Price Details" />

      <DisplaySuccessMessages successMessages={successMessages} />
      <DisplayErrorMessages errorMessages={errorMessages} />
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-4">
          <RadioGroupComponent
            id="plan-type-radio-btn-action"
            data-testid="claim-audit-detail-plantype"
            labelName="Plan Type"
            required
            reqColor
            optionList={planTypeData}
            defaultValue={inputValues.planType}
            filterAction={(e) => {
              setInputValues({ ...inputValues, planType: e });
              dispatch(
                storePriceSearchInputData({
                  ...getInputValues,
                  planType: e,
                })
              );
            }}
            className="log-batch-filter-radio"
          />
        </div>

        {/* REBATE PROGRAM DROPDOWN */}

        <div className="col-sm-6 col-md-6 col-lg-4">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Rebate Program &nbsp;
              <span className="mandatory"> *</span>
            </legend>
            <div className="form-wrapper db p-0">
              <div className="mui-custom-form with-select field-xl no-lbl">
                <TextField
                  name="rebateProgram"
                  data-testid="rebate_program"
                  id="rebate_program"
                  label="Rebate Program"
                  fullWidth
                  select
                  required
                  inputProps={{
                    maxLength: 11,
                    id: 'rebate_program',
                    required: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className="frr-display-hidden-label mandate-fields"
                  error={
                    rebatePgmErrorMsg?.filter((x) => {
                      return x?.includes('Rebate Program is');
                    }).length > 0
                      ? rebatePgmErrorMsg
                      : null
                  }
                  helperText={
                    rebatePgmErrorMsg?.filter((x) => {
                      return x?.includes('Rebate Program is');
                    }).length > 0
                      ? rebatePgmErrorMsg
                      : null
                  }
                  value={inputValues && inputValues.rebateProgram}
                  onChange={handleChange}
                  onBlur={handleOnBlur}
                >
                  <MenuItem
                    key=""
                    value="-1"
                    className="frr-dropdown-blank-item"
                  />
                  {isArr(rebatePgmList)
                    ? rebatePgmList.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
            </div>
          </fieldset>
        </div>

        {/* QUARTER */}
        <div className="col-sm-6 col-md-6 mt-sm-3 mt-lg-0 col-lg-4">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Quarter &nbsp;
              <span className="mandatory"> *</span>
            </legend>
            <div className="form-wrapper p-0">
              <div className="mui-custom-form with-select field-xl no-lbl">
                <TextField
                  name="quarter"
                  id="quarter"
                  label="Quarter"
                  fullWidth
                  data-testid="Quarter"
                  required
                  inputProps={{ maxLength: 6, id: 'quarter' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className="frr-display-hidden-label mandate-fields"
                  error={
                    quarterErrorMsg?.filter((x) => {
                      return (
                        x?.includes('Quarter is required') ||
                        x?.includes('Please enter a valid quarter and year in')
                      );
                    }).length > 0
                      ? quarterErrorMsg
                      : null
                  }
                  helperText={
                    quarterErrorMsg?.filter((x) => {
                      return (
                        x?.includes('Quarter is required') ||
                        x?.includes('Please enter a valid quarter and year in')
                      );
                    }).length > 0
                      ? quarterErrorMsg
                      : null
                  }
                  value={inputValues.quarter}
                  onChange={handleChange}
                  onBlur={handleOnBlur}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row row_wrap">
        {!fullScreenView2 && (
          <div className={`col-${!fullScreenView1 ? 'sm-6' : 'sm-12'} mt-4`}>
            {tableState || manufacturerList?.length === 0 ? (
              <TableGrid
                ref={gridRef}
                rowData={manufacturerList}
                columnDefs={manuFactureHead}
                handleFullScreenViewClick={() => handleFullScreenView(1)}
                fullScreenView={fullScreenView1}
                gridHeight={fullScreenView1 ? '70vh' : 400}
                helpMessage="Manufacturer Selection"
                onSelect={(e) => onSelectAction(e)}
                enterMovesDown
                suppressCellFocus
                exportFile
                data-testid="onEditingStopped"
                fileName="Manufacturer"
                gridCall={onGridReady}
              />
            ) : null}
          </div>
        )}
        {!fullScreenView1 && (
          // inputValues.drugFamily === 'drug' &&
          <div className={`col-${!fullScreenView2 ? 'sm-6' : 'sm-12'} mt-4`}>
            <TableGrid
              ref={gridRef}
              rowData={drugFamilyList}
              columnDefs={drugFamilyTableData}
              handleFullScreenView={false}
              handleFullScreenViewClick={() => handleFullScreenView(2)}
              fullScreenView={fullScreenView2}
              gridHeight={fullScreenView2 ? '70vh' : 400}
              helpMessage="Drug Family Selection"
              enterMovesDown
              suppressCellFocus
              exportFile
              cellClickedListener={(e) => onClickOnViewPriceDetail(e)}
              data-testid="onEditingStopped2"
              fileName="Drug Family Selection"
              gridCall={onGridReadyDrugFamily}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RebatePriceSearch;
